export default "__VITE_ASSET__DOT5fDGG__"